/**
 * Alta de un paciente PROPIO del terapeuta (sin padre). Datos mínimos clínicos:
 * nombre, fecha de nacimiento (→ banda PEFF la calcula el backend), sexo, notas.
 * Paridad con el alta del padre (nombre + fecha) + campos clínicos.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { childrenApi } from "../../api/endpoints.js";
import { ScreenHeader, Content } from "../../components/Layout.js";
import { Card } from "../../components/Card.js";
import { Button } from "../../components/Button.js";
import { ErrorBanner, Field, TextInput, Select } from "../../components/Form.js";
import { mensajeDeError } from "../../hooks/useQuery.js";

export function NewPatientPage() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [fechaNacimiento, setFecha] = useState("");
  const [sexo, setSexo] = useState<"" | "M" | "F" | "X">("");
  const [notas, setNotas] = useState("");
  const [declaracion, setDeclaracion] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function crear() {
    setError(null);
    if (!nombre.trim()) return setError("El nombre es obligatorio.");
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fechaNacimiento)) return setError("Fecha de nacimiento inválida.");
    if (!declaracion) return setError("Debes declarar que cuentas con la autorización del tutor.");
    setOcupado(true);
    try {
      const pac = await childrenApi.crearPaciente({
        nombre: nombre.trim(),
        fechaNacimiento,
        declaracionConsentimiento: true,
        ...(sexo ? { sexo } : {}),
        ...(notas.trim() ? { notas: notas.trim() } : {}),
      });
      navigate(`/terapeuta/paciente/${pac.id}`);
    } catch (e) {
      setError(mensajeDeError(e));
    } finally {
      setOcupado(false);
    }
  }

  return (
    <>
      <ScreenHeader title="Nuevo paciente" back="/terapeuta/pacientes" />
      <Content>
        <Card>
          {error ? <ErrorBanner message={error} /> : null}
          <Field label="Nombre">
            <TextInput value={nombre} onChange={(e) => setNombre(e.target.value)} />
          </Field>
          <Field label="Fecha de nacimiento" hint="La banda PEFF se calcula automáticamente.">
            <TextInput type="date" value={fechaNacimiento} onChange={(e) => setFecha(e.target.value)} />
          </Field>
          <Field label="Sexo">
            <Select value={sexo} onChange={(e) => setSexo(e.target.value as "" | "M" | "F" | "X")}>
              <option value="">—</option>
              <option value="F">Femenino</option>
              <option value="M">Masculino</option>
              <option value="X">Otro / no especifica</option>
            </Select>
          </Field>
          <Field label="Notas (opcional)">
            <TextInput value={notas} onChange={(e) => setNotas(e.target.value)} />
          </Field>
          <label
            style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 12, fontSize: 14 }}
          >
            <input
              type="checkbox"
              checked={declaracion}
              onChange={(e) => setDeclaracion(e.target.checked)}
              style={{ marginTop: 3 }}
            />
            <span>
              Cuento con la autorización del tutor para evaluar y procesar la voz del menor.
            </span>
          </label>
          <div style={{ marginTop: 12 }}>
            <Button
              variant="primary"
              block
              disabled={ocupado || !declaracion}
              onClick={() => void crear()}
            >
              {ocupado ? "Creando…" : "Crear paciente"}
            </Button>
          </div>
        </Card>
      </Content>
    </>
  );
}
